module.exports = {"430408001":"蒸湘街道","430408002":"红湘街道","430408004":"联合街道","430408100":"呆鹰岭镇","430408101":"雨母山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430408.json
// module id = 1960
// module chunks = 0